import { useState, useEffect } from 'react'
import { Stack } from '@mui/material'
import { useAuth } from '../../contexts/AuthContext'
import { usePost } from './../../apis/ApiRequests'
import { useNavigate } from 'react-router-dom'
import HeaderMobile from './components/Header'
import MenuIconMobile from './components/MenuIcon'
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import PreviewIcon from '@mui/icons-material/Preview'
import { addDays, format } from 'date-fns'
import { stringToDate } from '../../utils/Library'

const HomeMobile = () => {

    const { authInfo } = useAuth()
    const navigate = useNavigate()
    
    const today = format(addDays(new Date(), 0), 'yyyy-MM-dd')

	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode = authInfo.facilityCode
    const facilityName = authInfo.facilityName
    const userId       = authInfo.userId
    const userName     = authInfo.userName
    const authority    = authInfo.authority
    const traderCode   = authInfo.traderCode
    const trader       = authInfo.trader
    
	//-----------------------------------------------
	// initialize - useState
	//-----------------------------------------------
    const [ prevBidDate_1 , setPrevBidDate_1  ] = useState('')
    const [ prevBidDate_2 , setPrevBidDate_2  ] = useState('')
	const [ dataGridHeight, setDataGridHeight ] = useState(window.innerHeight - 0)

	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - 過去入札日の参照
	//-----------------------------------------------
    const { response : getPrevBidDate_res, post:getPrevBidDate_post } = usePost()
    const getPrevBidDate = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getPrevBidDate',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getPrevBidDate_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        getPrevBidDate()
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 0)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    },[])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getPrevBidDate / bidList)
	//-----------------------------------------------
    useEffect(() => {
        setPrevBidDate_1('')
        setPrevBidDate_2('')
        if (getPrevBidDate_res) {
            setPrevBidDate_1(stringToDate(getPrevBidDate_res.prevDate1))
            setPrevBidDate_2(stringToDate(getPrevBidDate_res.prevDate2))
        }
    }, [getPrevBidDate_res])

    const handleClick = (menu) => {
        navigate(menu)
    }

    return (
        <>
            <HeaderMobile />
            <div style={{marginTop:'60px', width: '100%', height: dataGridHeight, marginBottom: '10px', overflowY:'scroll'}}>
                    <div style={{padding:'1rem'}}>
                        <div style={{padding:'0px 20px 0px 20px', fontSize:'18px'}}>
                            <div style={{float:'left', padding:'10px'}}>
                                <AccountBoxIcon style={{ fontSize: 70,color:'#305496' }} />
                            </div>
                            <div style={{float:'left', padding:'15px'}}>
                                <div>ID : { userId }</div>
                                <div style={{color:'#305496', fontSize:'20px', fontWeight:'bold'}}>{ userName } / { trader }</div>
                            </div>
                            <div style={{clear:'both'}}></div>
                        </div>
                        <MenuIconMobile header="Bid Menu" title="入札に参加する"  onClick={() => handleClick(`/bidGroupMobile?targetDate=${today}&bidGroupNo=`)}>
                            <AccessAlarmIcon style={{fontSize: '4rem', color: '#305496'}} />
                        </MenuIconMobile>
                        {
                            prevBidDate_1 ?
                            <MenuIconMobile header="Bid Menu" title={`${prevBidDate_1}の結果`}  onClick={() => handleClick(`/bidGroupMobile?targetDate=${prevBidDate_1}&bidGroupNo=`)}>
                                <PreviewIcon style={{fontSize: '4rem', color: '#305496'}} />
                            </MenuIconMobile>
                            :
                            <></>
                        }
                        {
                            prevBidDate_2 ?
                            <MenuIconMobile header="Bid Menu" title={`${prevBidDate_2}の結果`}  onClick={() => handleClick(`/bidGroupMobile?targetDate=${prevBidDate_2}&bidGroupNo=`)}>
                                <PreviewIcon style={{fontSize: '4rem', color: '#305496'}} />
                            </MenuIconMobile>
                            :
                            <></>
                        }
                        <Stack direction='row' alignItems='flex-start' sx={{mt: 10}}></Stack>
                    </div>
            </div>
        </>
    )
}

export default HomeMobile